import { activeCouncilNames, shortCouncilName } from '../../config/registry';
import Skeleton from './DashboardSkeleton-v1';

const ALL_COUNCILS = activeCouncilNames();

export default function DashboardStatusSection({
  loading, st, councils, theme, collapsed: statusCollapsed, onToggle: toggleStatusCollapsed,
}) {
  const regionLabel = councils.length === ALL_COUNCILS.length
    ? "Northern Rivers"
    : councils.length === 0
      ? "No councils"
      : councils.map(shortCouncilName).join(", ");

  return (
    <div style={{marginBottom:12}}>
      <div
        onClick={toggleStatusCollapsed}
        role="button" aria-expanded={!statusCollapsed} tabIndex={0}
        onKeyDown={e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();toggleStatusCollapsed();}}}
        style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",cursor:"pointer",userSelect:"none"}}
      >
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#6a80a0" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
            style={{transform:statusCollapsed?"rotate(0deg)":"rotate(90deg)",transition:"transform 0.2s",flexShrink:0}}>
            <polyline points="9 18 15 12 9 6"/>
          </svg>
          <span style={{color:theme.textMuted,fontSize:12,fontWeight:600,textTransform:"uppercase",letterSpacing:0.5}}>Status Overview</span>
        </div>
        <span style={{color:"#6a80a0",fontSize:11}}>{regionLabel}</span>
      </div>
      {!statusCollapsed && (
      <div style={{display:"flex",gap:8,marginBottom:4}}>
        {[
          {label:"Total",     v: loading ? null : st.total, sub: "active DAs",        color: theme.text  },
          {label:"Assessing", v: loading ? null : st.ass,   sub: "under assessment",  color: theme.accent},
          {label:"Exhibition",v: loading ? null : st.exh,   sub: "on exhibition",     color: "#d49060"   },
          {label:"Approved",  v: loading ? null : st.app,   sub: "approved / determined", color: "#5aba6a"},
        ].map(s => (
          <div key={s.label} style={{
            flex:1, background:theme.bgCard, border:`1px solid ${theme.border}`,
            borderRadius:10, padding:"8px 10px",
            boxShadow:"0 2px 8px rgba(0,0,0,0.3)",
          }}>
            <div style={{color:"#6a80a0",fontSize:10,textTransform:"uppercase",letterSpacing:0.5}}>{s.label}</div>
            {loading
              ? <Skeleton width="32px" height="28px" bg={theme.border} />
              : <div style={{color:s.color,fontSize:24,fontWeight:800,lineHeight:1.1}}>{s.v}</div>
            }
            <div style={{color:"#6a80a0",fontSize:10,marginTop:2}}>{s.sub}</div>
          </div>
        ))}
      </div>
      )}
    </div>
  );
}
